// frontend/src/features/categories/Category.js
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPenToSquare, faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from 'react-router-dom';
import { useDeleteCategoryMutation, selectCategoryByIdForAdmin } from './categoriesApiSlice';
import { memo } from 'react';
import { Spinner } from "react-bootstrap";
import { useSelector } from "react-redux";
import useAuth from '../../hooks/useAuth';

const Category = ({ categoryId, index }) => {
    const { isManager, isAdmin } = useAuth();

    const { pageNumber = 1, searchQuery = '', isActiveFilter = '' } = useSelector((state) => state.category);
    const queryArgs = { page: pageNumber, search: searchQuery, isActive: isActiveFilter };

    const category = useSelector(state =>
        selectCategoryByIdForAdmin(state, queryArgs, categoryId) // Correct usage with queryArgs
    );

    const [deleteCategory, {
        isLoading: isDeleting,
        isSuccess: isDelSuccess,
        isError: isDelError,
        error: delError
    }] = useDeleteCategoryMutation();

    const onDeleteCategoryClicked = async () => {
        if (window.confirm("Are you sure you want to delete this category? All related content will also be removed.")) {
            await deleteCategory({ id: categoryId });
        }
    };

    const navigate = useNavigate();

    const handleEdit = () => navigate(`/dashboard/categories/${categoryId}`); // Assuming your route is /dash/categories/:id

    if (category) {
        return (
            <>
                <tr className="table__row">
                    <td className="table__cell">{index + 1}</td>
                    <td className="table__cell">{category.name}</td>
                    <td className="table__cell">{category.description || '-'}</td>
                    <td className="table__cell">
                        {category.imageUrl ? (
                            <img src={category.imageUrl} alt="Category Icon" style={{ width: '50px', height: 'auto' }} className="rounded" />
                        ) : (
                            'No Image'
                        )}
                    </td>
                    <td className="table__cell">{category.order}</td>
                    <td className="table__cell">
                        {category.isActive ? 'Yes' : 'No'}
                    </td>
                    <td className="table__cell">
                        <button
                            className="icon-button table__button me-2"
                            onClick={handleEdit}
                        >
                            <FontAwesomeIcon icon={faPenToSquare} />
                        </button>
                        {(isManager || isAdmin) && (
                            <button
                                className="icon-button table__button text-danger"
                                onClick={onDeleteCategoryClicked}
                                disabled={isDeleting}
                            >
                                {isDeleting ? <Spinner animation="border" size="sm" /> : <FontAwesomeIcon icon={faTrashCan} />}
                            </button>
                        )}
                    </td>
                </tr>
                {isDelError && (
                    <tr>
                        <td colSpan={7} className="text-center text-danger">
                            {delError?.data?.message || "Error deleting category."}
                        </td>
                    </tr>
                )}
            </>
        );
    } else {
        return null;
    }
};

const memoizedCategory = memo(Category);

export default memoizedCategory;